import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 4.5rem;
`
export const Link = styled.div`
  font-size: 2rem;
  border-bottom: 0.2rem solid #fff;
`
